module.exports = __webpack_public_path__ + "media/images/type_web-37f7da77.png";